import React from 'react';
import { FunnelIcon } from '@heroicons/react/24/solid';
import DropdownType from './DropdownType';
import DropdownSelect from 'shared_items/DropdownSelect';

// Movido de health/components/filters_records.jsx para health/moduleComponents/FiltersRecords.jsx
// (alinhando health ao padrão de nome de pasta/arquivo dos demais módulos — fase 3).
// Shared by both tab_records and tab_summary — one filter bar, two consumers.
export const FiltersRecords = ({
  filterDescription,
  setFilterDescription,
  filterArea,
  setFilterArea,
  filterType,
  setFilterType,
  areas,
  types,
  handleClearFilters,
}) => {
  return (
    <div className="bg-white mb-4 rounded-2xl shadow flex-1">

      {/* Filters Fields */}    
      <div className="flex flex-col md:flex-row md:items-center md:gap-4 gap-4 mb-4 p-4 pb-4">
        {/* Button and Search */}
        <div className="flex items-center w-full md:w-4/5 gap-2">
          <button
            onClick={handleClearFilters}
            className="py-2 px-3 bg-gray-200 text-gray-700 rounded-full hover:bg-gray-300 text-base"
          >
            <FunnelIcon className="h-5 w-5" />
          </button>
          <input
            type="text"
            placeholder="Search description, professional or area"
            value={filterDescription}
            onChange={(e) => setFilterDescription(e.target.value)}
            className="py-1 px-2 md:py-2 md:px-3 text-sm md:text-base flex-1 bg-white border border-gray-300 rounded-xl shadow-sm focus:ring-2 focus:ring-blue-200 focus:border-blue-500"
          />
        </div>

        {/* Dropdown Area and Type */}
        <div className="flex flex-row gap-2 w-full">
          <div className="w-1/2 min-w-0">
            <DropdownSelect
              value={filterArea}
              onChange={setFilterArea}
              options={areas}
              showAllOption
              allOptionText="All Areas"
              className="!bg-white border border-gray-300 shadow-sm"
            />
          </div>

          <div className="w-1/2 min-w-0">
            <DropdownType
              value={filterType}
              onChange={setFilterType}
              showAllOption
              allOptionText="All Topics"
              className="!bg-white border border-gray-300 shadow-sm"
            />
          </div>
        </div>
      </div>

    </div>
  );
};
